import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { Itens } from "app/types/ConusltarItens"
import { IItemOrcamento } from "app/types/IItemOrcamento"


import globalMU from "globalMU"

declare var window: any

export type AlterarTipoentregaItemInput = {
    identificadorItem: number,
    codigoTipoEntrega:string,
    itemOrcamento: IItemOrcamento
}

export async function alterarTipoEntregaItem(input: AlterarTipoentregaItemInput) {
    try {
        globalMU.blockUI({ tryPassiveLoading: true })

        const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarTipoEntregaItem(
            store.getState().orcamento.IdentificadorOrcamento,
            input.codigoTipoEntrega,
            input.identificadorItem
        )
    
        const atualizarOrcamento = () => {
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem);
            
            if (input.itemOrcamento.CodigoTipoEntregaAlteradoAcoes && itemAtualizado.VendaSobEncomenda && input.itemOrcamento.VendaSobEncomenda != itemAtualizado.VendaSobEncomenda) {
                globalMU.showWarnMessage("Produto " + itemAtualizado.Codigo + " definido sob encomenda.")
            }
    
            store.dispatch(atualizarItemAction({ identificador: input.identificadorItem, dados: itemAtualizado }))
            store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
        }


/* 477181 mesmo se der err, mas tiver dados (ItensOrcamento), tem q atualizar
        if (!("HasErrors" in orcamentoAtualizado) || !orcamentoAtualizado["HasErrors"]) {
            atualizarOrcamento()
           
        }
            */
        if (orcamentoAtualizado && orcamentoAtualizado.ItensOrcamento && orcamentoAtualizado.ItensOrcamento.length > 0) // 477181
        { // mesmo se der err, mas tiver dados (ItensOrcamento), tem q atualizar
            atualizarOrcamento() // 477181
        }
    } finally {
        globalMU.unblockUI()
    }
}